import { render } from "./AdminEnrichmentSettings.vue?vue&type=template&id=a764eb04&scoped=true"
import script from "./AdminEnrichmentSettings.vue?vue&type=script&lang=js"
export * from "./AdminEnrichmentSettings.vue?vue&type=script&lang=js"

import "./AdminEnrichmentSettings.vue?vue&type=style&index=0&id=a764eb04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a764eb04"]])

export default __exports__